import React from 'react';
import PropTypes from 'prop-types';
import Carousel from 'react-material-ui-carousel';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import useStyles from './styles';

const ImageCarousel = props => {
  const { items } = props;
  const classes = useStyles();

  return (
    <Carousel animation="slide" autoPlay={true} className={classes.carouselRoot}>
      {items.map(carouselItem => {
        const { name, description, onClick, id, backgroundImage } = carouselItem;

        const onClickHanler = () => onClick(id);

        return (
          <Paper className={classes.paperRoot} onClick={onClickHanler}>
            <img alt="My Watch" src={backgroundImage} style={{ maxHeight: '350px' }} width="100%" />
            <div className={classes.descriptionWrapper}>
              <Typography variant="h1">{name}</Typography>
              <Typography variant="h3">{description}</Typography>
            </div>
          </Paper>
        );
      })}
    </Carousel>
  );
};

ImageCarousel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      name: PropTypes.string,
      description: PropTypes.string,
      onClick: PropTypes.func,
      backgroundImage: PropTypes.any,
    }),
  ),
};

ImageCarousel.defaultProps = {
  items: [],
};

export default ImageCarousel;
